<template lang="">
    <div id="content">
      <div class="global_area">
        <div class="path"><a href="#none">Home</a> &gt; <a href="#none">상품 관리</a> &gt; <strong>기부후원 단체 리스트</strong></div>
        <h2 class="h_sub">기부후원 단체 리스트</h2>
      </div>
      
      <DonationGroupManageListForm/>
    </div>
  </template>
  
  <script>
  import DonationGroupManageListForm from '@/components/admin/board/DonationGroupManageListForm.vue';
  
  export default {
    components: {
      DonationGroupManageListForm
    }
  }
  </script>
  <style lang="">
      
  </style>